interface Term {
  term: string;
  slug: string;
  definition: string;
  extendedDescription?: string;
  category: string;
  relatedTerms?: { term: string; slug: string }[];
}

export const allTerms: Term[] = [
  {
    term: "Aanraakspanning",
    slug: "aanraakspanning",
    definition:
      "De spanning die kan ontstaan tussen geleidende delen wanneer deze gelijktijdig worden aangeraakt.",
    extendedDescription:
      "Aanraakspanning is een belangrijk veiligheidsconcept in de elektrotechniek. Het gaat om de spanning die iemand kan ervaren bij het aanraken van een elektrische installatie. De maximaal toegestane aanraakspanning is vastgelegd in veiligheidsnormen om elektrische schokken te voorkomen.",
    category: "Veiligheid",
    relatedTerms: [
      { term: "Aarding", slug: "aarding" },
      { term: "Aardlekschakelaar", slug: "aardlekschakelaar" },
    ],
  },
  {
    term: "Aarding",
    slug: "aarding",
    definition:
      "Aarding is the process of connecting an electrical installation to the earth to ensure safety. It provides a safe path for excess electrical current, such as during a short circuit or fault, to be safely discharged into the earth.",
    extendedDescription:
      "Aarding is a crucial component of every electrical installation, whether in residential or industrial settings. It ensures that in the event of a fault or short circuit, the electrical current is safely directed to the earth, significantly reducing the risk of electric shocks, fires, or other hazards. Without proper aarding, electrical voltage can accumulate, leading to dangerous situations. A well-installed grounding system is essential for protecting both people and equipment. Aarding is achieved using various components such as an aardpen, aarddraad, or aardrail.",
    category: "Veiligheid",
    relatedTerms: [
      { term: "Aardpen", slug: "aardpen" },
      { term: "Aardedraad", slug: "aardedraad" },
      { term: "Aarderail", slug: "aarderail" },
    ],
  },
  {
    term: "Lekkagebeveiliging",
    slug: "lekkagebeveiliging",
    definition:
      "Lekkagebeveiliging is het systeem of de technologie die wordt gebruikt om lekkages van water, gas, of andere vloeistoffen te detecteren en te voorkomen, om schade aan elektrische installaties en eigendommen te voorkomen.",
    extendedDescription:
      "Lekkagebeveiliging is van cruciaal belang voor de bescherming van woningen en bedrijven tegen de schadelijke effecten van water- of gaslekkages. Deze systemen kunnen sensoren bevatten die onmiddellijk een lekkage detecteren en automatische afsluitmechanismen activeren om verdere schade te voorkomen. Het gebruik van lekkagebeveiliging kan leiden tot besparingen op verzekeringskosten en minimaliseert het risico op ernstige schade aan elektrische installaties, apparatuur en andere waardevolle eigendommen. Het is een essentiële veiligheidsmaatregel in moderne installaties en wordt vaak geïntegreerd in smart home-systemen voor extra gemak en controle.",
    category: "Veiligheid",
    relatedTerms: [
      { term: "Waterschade", slug: "waterschade" },
      { term: "Gaslek", slug: "gaslek" },
      { term: "Beveiligingssystemen", slug: "beveiligingssystemen" },
    ],
  },
  {
    term: "Lichtnet",
    slug: "lichtnet",
    definition:
      "Het lichtnet is het netwerk van elektrische leidingen en transformatoren dat zorgt voor de distributie van elektriciteit naar woningen, bedrijven en andere gebruikers.",
    extendedDescription:
      "Het lichtnet vormt de ruggengraat van de elektriciteitsvoorziening in Nederland en veel andere landen. Het zorgt voor de distributie van laagspanningsstroom naar huishoudens en commerciële instellingen, zodat elektrische apparaten kunnen functioneren. Het lichtnet bestaat uit een complex systeem van kabels, transformatoren en schakelaars die samenwerken om een betrouwbare stroomvoorziening te bieden. Storingen in het lichtnet kunnen leiden tot uitval van elektriciteit, wat grote gevolgen kan hebben voor het dagelijks leven en de bedrijfsvoering. Het onderhoud en de veiligheid van het lichtnet zijn daarom van groot belang.",
    category: "Elektra",
    relatedTerms: [
      { term: "Elektriciteitsnet", slug: "elektriciteitsnet" },
      { term: "Stroomvoorziening", slug: "stroomvoorziening" },
      { term: "Transformator", slug: "transformator" },
    ],
  },
  {
    term: "Elektriciteitsnet",
    slug: "elektriciteitsnet",
    definition:
      "Het elektriciteitsnet is het uitgebreide netwerk van leidingen, kabels, transformatoren en andere infrastructuur die elektriciteit van elektriciteitscentrales naar huishoudens, bedrijven en industriële installaties transporteert.",
    extendedDescription:
      "Het elektriciteitsnet is de ruggengraat van de energievoorziening in een land. Het zorgt voor de distributie van elektriciteit van de elektriciteitscentrales naar eindgebruikers, zoals woningen en bedrijven. Het netwerk bestaat uit meerdere spanningsniveaus, van hoogspanningslijnen die elektriciteit over lange afstanden transporteren, tot laagspanningskabels die zorgen voor de aansluiting op individuele huishoudens en bedrijven. Het goed onderhouden van het elektriciteitsnet is cruciaal voor de betrouwbaarheid van de elektriciteitsvoorziening en het minimaliseren van storingen.",
    category: "Elektra",
    relatedTerms: [
      { term: "Lichtnet", slug: "lichtnet" },
      { term: "Stroomvoorziening", slug: "stroomvoorziening" },
      { term: "Energiecentrale", slug: "energiecentrale" },
    ],
  },

  {
    term: "Stroomvoorziening",
    slug: "stroomvoorziening",
    definition:
      "Stroomvoorziening verwijst naar het leveren van elektriciteit aan gebruikers via het elektriciteitsnet om apparatuur en verlichting te laten functioneren.",
    extendedDescription:
      "De stroomvoorziening is essentieel voor het dagelijks functioneren van huizen, bedrijven en industriële toepassingen. Het zorgt ervoor dat de benodigde elektriciteit beschikbaar is voor apparaten, verlichting, verwarming, koeling en meer. Stroomvoorziening kan op verschillende manieren worden geleverd, waaronder via het landelijke elektriciteitsnet of via alternatieve systemen zoals zonnepanelen of generatoren. Het handhaven van een betrouwbare stroomvoorziening is van groot belang om uitval te voorkomen en de continuïteit van elektrische apparatuur te waarborgen.",
    category: "Elektra",
    relatedTerms: [
      { term: "Elektriciteitsnet", slug: "elektriciteitsnet" },
      { term: "Stroom", slug: "stroom" },
      { term: "Noodstroomvoorziening", slug: "noodstroomvoorziening" },
    ],
  },

  {
    term: "Transformator",
    slug: "transformator",
    definition:
      "Een transformator is een elektrisch apparaat dat de spanning van elektriciteit verhoogt of verlaagt voor veilig gebruik in verschillende toepassingen.",
    extendedDescription:
      "Transformatoren spelen een essentiële rol in het elektriciteitsnet door het mogelijk te maken om de spanning van elektriciteit aan te passen. Hoogspanningslijnen gebruiken transformatoren om de spanning te verhogen voor transport over lange afstanden, waarna de spanning weer wordt verlaagd door transformatoren bij de eindgebruikers voor veilig gebruik in huishoudens en bedrijven. Ze worden ook gebruikt in verschillende industriële toepassingen om de spanning aan te passen aan de vereisten van machines en apparatuur. Transformatoren zorgen voor de efficiëntie van het elektriciteitsnet en voorkomen schade aan elektrische apparaten door ongeschikte spanningsniveaus.",
    category: "Elektra",
    relatedTerms: [
      { term: "Elektriciteitsnet", slug: "elektriciteitsnet" },
      { term: "Stroomvoorziening", slug: "stroomvoorziening" },
      { term: "Spanning", slug: "spanning" },
    ],
  },
  {
    term: "Lading",
    slug: "lading",
    definition:
      "Lading is de elektrische stroom die door een elektrisch circuit wordt gedragen, bijvoorbeeld de stroom die door apparaten of apparatuur wordt gebruikt.",
    extendedDescription:
      "Lading verwijst naar de elektrische energie die door een elektrisch circuit stroomt om apparaten van stroom te voorzien. Het kan worden uitgedrukt in coulomb (C) en is de basis voor het functioneren van veel elektrische apparaten. Lading is een fundamenteel concept in de elektrodynamica en wordt beïnvloed door de spanning en weerstand in een circuit. In een goed ontworpen circuit is de lading efficiënt verdeeld over de componenten om het gewenste resultaat te behalen, zoals verlichting, verwarming, of motorwerking.",
    category: "Elektra",
    relatedTerms: [
      { term: "Elektrische stroom", slug: "elektrische-stroom" },
      { term: "Spanning", slug: "spanning" },
      { term: "Weerstand", slug: "weerstand" },
    ],
  },

  {
    term: "Lichtsterkte",
    slug: "lichtsterkte",
    definition:
      "Lichtsterkte is de maat voor de hoeveelheid licht die door een lichtbron wordt uitgezonden, meestal uitgedrukt in candela (cd).",
    extendedDescription:
      "Lichtsterkte is een belangrijke factor bij de keuze van verlichting in elektrische installaties. Het bepaalt hoe fel een lichtbron schijnt en hoe goed deze een ruimte verlicht. Bij het ontwerpen van verlichting voor gebouwen, werkruimtes of buitenomgevingen is het belangrijk om de juiste lichtsterkte te kiezen voor de gewenste helderheid en functionaliteit. Lichtsterkte kan variëren afhankelijk van het type lichtbron, zoals LED-lampen, gloeilampen of halogeenlampen, en de toepassing waarvoor de verlichting wordt gebruikt.",
    category: "Elektra",
    relatedTerms: [
      { term: "Verlichting", slug: "verlichting" },
      { term: "Lux", slug: "lux" },
      { term: "Lumen", slug: "lumen" },
    ],
  },

  {
    term: "Loodkabel",
    slug: "loodkabel",
    definition:
      "Loodkabel is een type elektriciteitskabel met een beschermende laag van lood, vaak gebruikt voor ondergrondse installaties.",
    extendedDescription:
      "Loodkabels worden vaak gebruikt in omgevingen waar de kabels moeten worden beschermd tegen omgevingsfactoren, zoals vochtigheid of mechanische schade. De loodlaag biedt extra bescherming tegen corrosie en fysieke schade, wat loodkabels geschikt maakt voor ondergrondse toepassingen en andere veeleisende omgevingen. Hoewel loodkabels in het verleden veel werden gebruikt, worden ze tegenwoordig steeds vaker vervangen door milieuvriendelijkere alternatieven. Het gebruik van lood in kabels wordt steeds strenger gereguleerd vanwege de schadelijke effecten op het milieu en de gezondheid.",
    category: "Elektra",
    relatedTerms: [
      { term: "Kabel", slug: "kabel" },
      { term: "Aarding", slug: "aarding" },
      { term: "Isolatie", slug: "isolatie" },
    ],
  },

  {
    term: "Luchtbeveiliging",
    slug: "luchtbeveiliging",
    definition:
      "Luchtbeveiliging is een systeem dat de luchtcirculatie en -kwaliteit bewaakt en beschermt tegen elektrische storingen of overbelasting.",
    extendedDescription:
      "Luchtbeveiliging speelt een belangrijke rol in sommige elektrische installaties, vooral in industriële omgevingen waar er risico is op oververhitting of brand. Het systeem zorgt ervoor dat er voldoende luchtcirculatie is om warmte te dissiperen en elektrische apparatuur te koelen. Bij onvoldoende luchtbeveiliging kan er schade ontstaan door oververhitting, wat kan leiden tot brandgevaar of storingen. Dit systeem wordt vaak gecombineerd met temperatuur- en vochtigheidssensoren voor een compleet beheer van de omgeving waarin elektrische apparatuur zich bevindt.",
    category: "Elektra",
    relatedTerms: [
      { term: "Koeling", slug: "koeling" },
      { term: "Brandbeveiliging", slug: "brandbeveiliging" },
      { term: "Verwarming", slug: "verwarming" },
    ],
  },
  {
    term: "Aardpen",
    slug: "aardpen",
    definition:
      "Een aardpen is een metalen staaf die diep in de grond wordt geslagen om een veilige aardverbinding te maken in elektrische installaties. Deze pen zorgt ervoor dat overtollige elektrische stroom, zoals bij een kortsluiting, snel en veilig naar de aarde wordt afgevoerd. Het is een essentieel onderdeel van een goede aarding en biedt bescherming tegen elektrische schokken, brand en andere gevaren die kunnen ontstaan door foutieve elektrische stroom. Aardpennen worden vaak gebruikt in woningen, industriële omgevingen en bij het aanleggen van zonnepanelen om de veiligheid van het elektrische systeem te waarborgen.",
    category: "Veiligheid",
    relatedTerms: [
      { term: "Aarding", slug: "aarding" },
      { term: "Aardedraad", slug: "aardedraad" },
    ],
  },
  {
    term: "Aardedraad",
    slug: "aardedraad",
    definition:
      "Een aardedraad is een essentieel onderdeel van elektrische installaties, dat zorgt voor een veilige verbinding met de aarde. Dit voorkomt dat elektrische apparaten of installaties gevaarlijk hoge spanningen kunnen ontwikkelen. Het speelt een cruciale rol in de bescherming van mensen tegen elektrische schokken door overtollige elektrische stroom veilig af te voeren naar de aarde. Aardedraden worden meestal aangelegd in woningen, industriële installaties en andere elektrische systemen om de veiligheid te waarborgen.",
    category: "Veiligheid",
    relatedTerms: [
      { term: "Aarding", slug: "aarding" },
      { term: "Aarderail", slug: "aarderail" },
    ],
  },
  {
    term: "Aarderail",
    slug: "aarderail",
    definition:
      "Een koperen rail in de meterkast waar alle aarddraden samenkomen.",
    category: "Installatie",
    relatedTerms: [
      { term: "Aarding", slug: "aarding" },
      { term: "Aardedraad", slug: "aardedraad" },
    ],
  },
  {
    term: "Aardlekschakelaar",
    slug: "aardlekschakelaar",
    definition:
      "Een veiligheidsschakelaar die de stroom uitschakelt bij een lekstroom naar de aarde.",
    extendedDescription:
      "Een aardlekschakelaar is verplicht in moderne elektrische installaties en detecteert stroomverlies. Als er een lekstroom wordt gedetecteerd, schakelt de aardlekschakelaar het circuit direct uit om elektrische schokken te voorkomen.",
    category: "Veiligheid",
    relatedTerms: [
      { term: "Aarding", slug: "aarding" },
      { term: "Aardlekautomaat", slug: "aardlekautomaat" },
    ],
  },
  {
    term: "Aardlekautomaat",
    slug: "aardlekautomaat",
    definition:
      "Een combinatie van een aardlekschakelaar en een installatieautomaat.",
    extendedDescription:
      "Een aardlekautomaat biedt zowel bescherming tegen lekstromen als tegen overbelasting en kortsluiting. Dit maakt het een efficiënte en ruimtebesparende oplossing in groepenkasten.",
    category: "Veiligheid",
    relatedTerms: [
      { term: "Aardlekschakelaar", slug: "aardlekschakelaar" },
      { term: "Installatieautomaat", slug: "installatieautomaat" },
    ],
  },
  {
    term: "Installatieautomaat",
    slug: "installatieautomaat",
    definition:
      "Een zekering die automatisch uitschakelt bij overbelasting of kortsluiting.",
    extendedDescription:
      "Een installatieautomaat wordt gebruikt om elektrische circuits te beschermen. In tegenstelling tot smeltzekeringen hoeft een installatieautomaat niet vervangen te worden na een uitschakeling, maar kan deze eenvoudig worden gereset.",
    category: "Installatie",
    relatedTerms: [
      { term: "Aardlekautomaat", slug: "aardlekautomaat" },
      { term: "Groepenkast", slug: "groepenkast" },
    ],
  },
  {
    term: "Groepenkast",
    slug: "groepenkast",
    definition: "Het verdeelpunt van de elektrische installatie in een gebouw.",
    extendedDescription:
      "De groepenkast bevat installatieautomaten, aardlekschakelaars en andere beveiligingscomponenten. Het is het centrale punt waar elektriciteit wordt verdeeld over de verschillende groepen binnen een gebouw.",
    category: "Installatie",
    relatedTerms: [
      { term: "Aardlekschakelaar", slug: "aardlekschakelaar" },
      { term: "Installatieautomaat", slug: "installatieautomaat" },
    ],
  },
  {
    term: "B16",
    slug: "b16",
    definition: "Een installatieautomaat van 16 ampère met B-karakteristiek.",
    extendedDescription:
      "De B16-automaat is een veelgebruikte installatieautomaat in huishoudelijke installaties. Hij schakelt uit bij overbelasting en kortsluiting en is geschikt voor standaard elektrische apparaten en verlichting.",
    category: "Installatie",
    relatedTerms: [
      { term: "Installatieautomaat", slug: "installatieautomaat" },
      { term: "Groepenkast", slug: "groepenkast" },
    ],
  },
  {
    term: "Beltrafo",
    slug: "beltrafo",
    definition: "Een transformator voor deurbellen.",
    extendedDescription:
      "Een beltransformator verlaagt de netspanning naar een veilige spanning (meestal 8V, 12V of 24V) voor deurbelinstallaties. Hij wordt vaak in de groepenkast gemonteerd.",
    category: "Installatie",
    relatedTerms: [
      { term: "Transformator", slug: "transformator" },
      { term: "Groepenkast", slug: "groepenkast" },
    ],
  },
  {
    term: "CAT6",
    slug: "cat6",
    definition: "Een categorie netwerkkabel voor dataverkeer.",
    extendedDescription:
      "CAT6-kabels ondersteunen netwerksnelheden tot 10 Gbps op korte afstanden en hebben een betere signaalkwaliteit dan oudere categorieën zoals CAT5e.",
    category: "Netwerkinstallatie",
    relatedTerms: [
      { term: "CAT7", slug: "cat7" },
      { term: "RJ45", slug: "rj45" },
    ],
  },
  {
    term: "CAT7",
    slug: "cat7",
    definition: "Een verbeterde categorie netwerkkabel voor dataverkeer.",
    extendedDescription:
      "CAT7-kabels bieden betere afscherming en hogere bandbreedtes dan CAT6, waardoor ze geschikt zijn voor high-performance netwerken en serveromgevingen.",
    category: "Netwerkinstallatie",
    relatedTerms: [
      { term: "CAT6", slug: "cat6" },
      { term: "RJ45", slug: "rj45" },
    ],
  },
  {
    term: "Aansluitschema",
    slug: "aansluitschema",
    definition:
      "Een diagram dat de aansluitingen van een elektrisch systeem weergeeft.",
    category: "Installatie",
  },
  {
    term: "Aansluitwaarde",
    slug: "aansluitwaarde",
    definition:
      "De maximale belasting die een elektrische installatie kan dragen.",
    category: "Installatie",
  },
  {
    term: "Aantal module",
    slug: "aantal-module",
    definition:
      "Het aantal zonnepanelen of andere modules die in een installatie worden gebruikt.",
    category: "Zonnepanelen",
  },
  {
    term: "ABB",
    slug: "abb",
    definition:
      "Een internationaal bedrijf dat producten en systemen voor elektrische en elektronische installaties levert.",
    category: "Installatie",
  },
  {
    term: "AC (wisselstroom)",
    slug: "ac-wisselstroom",
    definition: "Elektrische stroom die periodiek van richting verandert.",
    category: "Basisbegrippen",
  },
  {
    term: "Adereindhulzen",
    slug: "adereindhulzen",
    definition:
      "Beschermende hulsjes die worden gebruikt om de uiteinden van elektrische draden te isoleren.",
    category: "Installatie",
  },
  {
    term: "Afdekplaat",
    slug: "afdekplaat",
    definition:
      "Een plaat die wordt gebruikt om een opening in een elektrisch apparaat of installatie af te dekken.",
    category: "Installatie",
  },
  {
    term: "Afdekraam",
    slug: "afdekraam",
    definition:
      "Een raam dat wordt gebruikt om schakelaars en stopcontacten te omkaderen en af te dekken.",
    category: "Installatie",
  },
  {
    term: "Afmonteren",
    slug: "afmonteren",
    definition:
      "Het laatste gedeelte van een installatie waarbij de apparatuur wordt gemonteerd en aangesloten.",
    category: "Installatie",
  },
  {
    term: "Armaturen",
    slug: "armaturen",
    definition:
      "Verlichtingstoestellen die zijn ontworpen voor elektrische verlichting in gebouwen en buitenruimtes.",
    category: "Installatie",
  },
  {
    term: "Attema",
    slug: "attema",
    definition:
      "Een merk dat producten levert voor de elektrotechnische en installatiebranche.",
    category: "Installatie",
  },
  {
    term: "Beugels",
    slug: "beugels",
    definition:
      "Hulpmiddelen die worden gebruikt voor het bevestigen van leidingen, kabels of andere installaties.",
    category: "Installatie",
  },
  {
    term: "Bewegingssensor",
    slug: "bewegingssensor",
    definition:
      "Een sensor die beweging detecteert en automatisch apparaten zoals verlichting inschakelt.",
    category: "Installatie",
  },
  {
    term: "Bliksemafleider",
    slug: "bliksemafleider",
    definition:
      "Een systeem dat is ontworpen om de gevolgen van blikseminslagen te verminderen door de energie naar de grond af te voeren.",
    category: "Veiligheid",
  },
  {
    term: "Bouwtekening",
    slug: "bouwtekening",
    definition:
      "Een gedetailleerde tekening van de bouwstructuur, inclusief elektrische installaties.",
    category: "Installatie",
  },
  {
    term: "Buitenverlichting",
    slug: "buitenverlichting",
    definition:
      "Verlichting die buiten een gebouw wordt geïnstalleerd, zoals tuinlampen en gevelverlichting.",
    category: "Installatie",
  },
  {
    term: "CAI",
    slug: "cai",
    definition: "Aansluitsysteem voor kabeltelevisie, radio en internet.",
    category: "Netwerkinstallatie",
  },
  {
    term: "CEE",
    slug: "cee",
    definition:
      "Een type stopcontact en stekker voor zware apparaten, vaak gebruikt in industriële omgevingen.",
    category: "Installatie",
  },
  {
    term: "Centraaldoos",
    slug: "centraaldoos",
    definition:
      "Een doos die wordt gebruikt om verschillende elektrische verbindingen centraal te verbinden.",
    category: "Installatie",
  },
  {
    term: "Circuitonderbreker",
    slug: "circuitonderbreker",
    definition:
      "Een automatisch inschakelapparaat dat de stroom onderbreekt bij een kortsluiting of overbelasting.",
    category: "Installatie",
  },
  {
    term: "Coax",
    slug: "coax",
    definition:
      "Een type kabel die wordt gebruikt voor het transporteren van signaal voor televisie en data.",
    category: "Netwerkinstallatie",
  },
  {
    term: "Combinatieschakeling",
    slug: "combinatieschakeling",
    definition:
      "Een schakeling waarbij meerdere componenten zoals lampen en schakelaars in combinatie werken.",
    category: "Installatie",
  },
  {
    term: "Connector",
    slug: "connector",
    definition:
      "Een mechanisch element dat twee elektrische geleiders verbindt.",
    category: "Installatie",
  },
  {
    term: "Coulomb",
    slug: "coulomb",
    definition: "De eenheid van elektrische lading in het SI-stelsel.",
    category: "Basisbegrippen",
  },
  {
    term: "Data",
    slug: "data",
    definition: "Informatie die digitaal kan worden opgeslagen en verwerkt.",
    category: "Netwerkinstallatie",
  },
  {
    term: "DC (gelijkstroom)",
    slug: "dc-gelijkstroom",
    definition: "Elektrische stroom die altijd in dezelfde richting vloeit.",
    category: "Basisbegrippen",
  },
  {
    term: "Demontage",
    slug: "demontage",
    definition:
      "Het proces van het verwijderen of afbreken van een installatie of apparatuur.",
    category: "Installatie",
  },
  {
    term: "Dimfunctie",
    slug: "dimfunctie",
    definition:
      "De mogelijkheid om de helderheid van een lamp of lichtbron te regelen.",
    category: "Installatie",
  },
  {
    term: "Dimmer",
    slug: "dimmer",
    definition:
      "Een apparaat dat wordt gebruikt om de helderheid van verlichting te regelen.",
    category: "Installatie",
  },
  {
    term: "DIN-rail",
    slug: "din-rail",
    definition:
      "Een type rail die in elektrische kasten wordt gebruikt om apparaten en componenten te monteren.",
    category: "Installatie",
  },
  {
    term: "Domotica",
    slug: "domotica",
    definition:
      "Slimme huistechnologie die gebruikt wordt voor het automatiseren van woningfuncties.",
    category: "Installatie",
  },
  {
    term: "Doorlaatwaarde",
    slug: "doorlaatwaarde",
    definition:
      "De maximale hoeveelheid stroom die door een kabel of apparaat kan stromen zonder schade.",
    category: "Basisbegrippen",
  },
  {
    term: "Dozenboor",
    slug: "dozenboor",
    definition:
      "Een boor die wordt gebruikt om gaten te maken voor het plaatsen van inbouwdozen in muren.",
    category: "Installatie",
  },
  {
    term: "Draadgoot",
    slug: "draadgoot",
    definition:
      "Een goot die wordt gebruikt om elektrische kabels op een veilige manier te geleiden.",
    category: "Installatie",
  },
  {
    term: "Duspol",
    slug: "duspol",
    definition:
      "Een soort spanningzoeker die wordt gebruikt om te controleren of er spanning op een kabel staat.",
    category: "Installatie",
  },
  {
    term: "Duurzaam",
    slug: "duurzaam",
    definition:
      "Een benadering waarbij rekening wordt gehouden met milieuvriendelijkheid en lange-termijn effecten.",
    category: "Duurzaamheid",
  },
  {
    term: "Eaton",
    slug: "eaton",
    definition: "Een wereldwijd bedrijf dat energiebeheeroplossingen biedt.",
    category: "Installatie",
  },
  {
    term: "Elektricien",
    slug: "elektricien",
    definition:
      "Een vakman die gespecialiseerd is in elektrische installaties en onderhoud.",
    category: "Installatie",
  },
  {
    term: "Elektrode",
    slug: "elektrode",
    definition:
      "Een geleider die wordt gebruikt om stroom in of uit een elektrisch medium te sturen.",
    category: "Installatie",
  },
  {
    term: "Energie",
    slug: "energie",
    definition:
      "De capaciteit om arbeid te verrichten, bijvoorbeeld in de vorm van elektriciteit.",
    category: "Basisbegrippen",
  },
  {
    term: "Energie rekening",
    slug: "energie-rekening",
    definition:
      "Een periodieke factuur die het energieverbruik van een gebouw of huishouden toont.",
    category: "Duurzaamheid",
  },
  {
    term: "Externe groepenkast",
    slug: "externe-groepenkast",
    definition:
      "Een groepenkast die buiten een gebouw wordt geïnstalleerd, bijvoorbeeld in een tuin of op een fabrieksterrein.",
    category: "Installatie",
  },
  {
    term: "Fase",
    slug: "fase",
    definition:
      "Een fase in een elektrisch systeem is een geleider die de elektrische stroom van het ene punt naar een ander punt transporteert.",
    category: "Installatie",
    relatedTerms: [
      { term: "Faseleiding", slug: "faseleiding" },
      { term: "Fasenspanning", slug: "fasenspanning" },
    ],
  },
  {
    term: "Faseleiding",
    slug: "faseleiding",
    definition:
      "Een elektrische draad die een specifieke fase van een elektrisch systeem verbindt.",
    category: "Installatie",
    relatedTerms: [
      { term: "Fase", slug: "fase" },
      { term: "Neutraler", slug: "neutraler" },
    ],
  },
  {
    term: "Fasenspanning",
    slug: "fasenspanning",
    definition:
      "De spanning die bestaat tussen twee fasen in een driefasig systeem.",
    category: "Basisbegrippen",
    relatedTerms: [
      { term: "Fase", slug: "fase" },
      { term: "Driefase", slug: "driefase" },
    ],
  },
  {
    term: "Driefase",
    slug: "driefase",
    definition:
      "Een elektrisch systeem waarbij drie fasen van elektrische stroom worden gebruikt, wat zorgt voor een stabiele en efficiënte energieoverdracht.",
    extendedDescription:
      "Driefasige systemen worden veel gebruikt in industriële en commerciële toepassingen voor het aandrijven van zware machines en apparaten. Dit systeem biedt een constante stroom van energie, wat resulteert in een gelijkmatiger gebruik van de elektrische capaciteit.",
    category: "Installatie",
    relatedTerms: [
      { term: "Fasenspanning", slug: "fasenspanning" },
      { term: "Fase", slug: "fase" },
    ],
  },
  {
    term: "Generator",
    slug: "generator",
    definition:
      "Een apparaat dat mechanische energie omzet in elektrische energie.",
    category: "Installatie",
    relatedTerms: [
      { term: "Alternator", slug: "alternator" },
      { term: "Stroom", slug: "stroom" },
    ],
  },
  {
    term: "Gelijkrichter",
    slug: "gelijkrichter",
    definition:
      "Een apparaat dat wisselstroom (AC) omzet naar gelijkstroom (DC).",
    category: "Installatie",
    relatedTerms: [
      { term: "Transformator", slug: "transformator" },
      { term: "Rectificatie", slug: "rectificatie" },
    ],
  },
  {
    term: "Transformator",
    slug: "transformator",
    definition:
      "Een apparaat dat de spanning van wisselstroom verhoogt of verlaagt.",
    category: "Installatie",
    relatedTerms: [
      { term: "Gelijkrichter", slug: "gelijkrichter" },
      { term: "Stroom", slug: "stroom" },
    ],
  },
  {
    term: "Kortsluiting",
    slug: "kortsluiting",
    definition:
      "Een ongewenste verbinding tussen twee geleiders die leidt tot een te grote stroom.",
    extendedDescription:
      "Kortsluitingen kunnen leiden tot beschadiging van elektrische apparatuur en zijn gevaarlijk vanwege de verhoogde kans op brand en elektrische schokken.",
    category: "Veiligheid",
    relatedTerms: [
      { term: "Zekering", slug: "zekering" },
      { term: "Installatieautomaat", slug: "installatieautomaat" },
    ],
  },
  {
    term: "Zekering",
    slug: "zekering",
    definition:
      "Een beschermingscomponent die de stroom in een elektrisch circuit onderbreekt bij een te hoge stroom.",
    extendedDescription:
      "Zekeringen worden gebruikt om te voorkomen dat een elektrische installatie beschadigd raakt door overbelasting. Ze zijn ontworpen om te doorbranden bij een stroom die de veilige waarde overschrijdt.",
    category: "Veiligheid",
    relatedTerms: [
      { term: "Kortsluiting", slug: "kortsluiting" },
      { term: "Installatieautomaat", slug: "installatieautomaat" },
    ],
  },
  {
    term: "Kabelgoot",
    slug: "kabelgoot",
    definition:
      "Een goot die wordt gebruikt voor het veilig en overzichtelijk geleiden van kabels in een gebouw.",
    category: "Installatie",
    relatedTerms: [
      { term: "Draadgoot", slug: "draadgoot" },
      { term: "Kabel", slug: "kabel" },
    ],
  },
  {
    term: "Kabel",
    slug: "kabel",
    definition:
      "Een verzameling van geleiders die samen een elektrisch signaal of stroom transporteren.",
    category: "Installatie",
    relatedTerms: [
      { term: "Kabelgoot", slug: "kabelgoot" },
      { term: "Draad", slug: "draad" },
    ],
  },
  {
    term: "Installatiedraad",
    slug: "installatiedraad",
    definition:
      "Een draad die specifiek is ontworpen voor gebruik in elektrische installaties.",
    category: "Installatie",
    relatedTerms: [
      { term: "Kabel", slug: "kabel" },
      { term: "Draad", slug: "draad" },
    ],
  },
  {
    term: "Draad",
    slug: "draad",
    definition:
      "Een dunne geleider die gebruikt wordt in elektrische installaties om stroom te transporteren.",
    category: "Installatie",
    relatedTerms: [
      { term: "Kabel", slug: "kabel" },
      { term: "Installatiedraad", slug: "installatiedraad" },
    ],
  },
];

// Sort the terms by 'term' alphabetically
allTerms.sort((a, b) => a.term.localeCompare(b.term));
